module.exports = __webpack_public_path__ + "static/media/roller02.223735c3.jpg";